<button
  pButton
  class="my-3"
  (click)="open();"
>
  {{newUserText}}
</button>
<p-card>
  <p-table
    [value]="(service.results$ | async) ?? []"
    dataKey="_id"
    styleClass="p-datatable-sm"
    selectionMode="single"
    [(selection)]="selectedUser"
    (onRowSelect)="selectUserForEdit($any($event.data))"
  >
    <ng-template #header>
      <tr>
        <ng-container *ngFor="let column of columns">
          <th
            *ngIf="column.fieldName && !column.disableSort"
            [pSortableColumn]="column.fieldName"
          ><ng-container *ngTemplateOutlet="headerContentTpl; context: { column: column }"></ng-container> <p-sort-icon
              [field]="column.fieldName"
            /></th>
          <th *ngIf="!column.fieldName || column.disableSort"><ng-container
              *ngTemplateOutlet="headerContentTpl; context: { column: column }"
            ></ng-container></th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template
      #headerContentTpl
      let-column="column"
    >
      <ng-container *ngIf="column.headerTemplate; else headerLabelTpl">
        <ng-container *ngTemplateOutlet="column.headerTemplate"></ng-container>
      </ng-container>
      <ng-template #headerLabelTpl>{{ getColumnLabel(column) }}</ng-template>
    </ng-template>
    <ng-template
      #body
      let-user
    >
      <tr [pSelectableRow]="user">
        <td *ngFor="let column of columns">
          <ng-container *ngTemplateOutlet="column.template ?? defaultCellTpl; context: {
              value: user[column.fieldName],
              rowData: user,
              data: user,
              cell: column,
              colData: column,
              cellData: column
            }"></ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td
          [attr.colspan]="columns.length"
          i18n="@@userManagementNoData"
        >Noch keine Nutzer vorhanden.</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

<ng-template
  #defaultCellTpl
  let-data="data"
  let-cell="cell"
>{{data[cell.fieldName]}}</ng-template>

<p-drawer
  #editUserDrawer
  [(visible)]="editVisible"
  position="right"
  [style]="{width: 'min(880px, 95vw)'}"
  (onHide)="closeEditUser()"
>
  <ng-template #header>
    <span
      class="fs-6 fw-bold"
      i18n="@@globalEdit"
    >Bearbeiten</span>
  </ng-template>
  <div *ngIf="editUser">
    <app-form
      #form
      [data]="editUser"
      [formFields]="formFields"
      [hideDeleteButton]="!deleteButton"
      [translatedLabels]="translatedLabels"
      [showActions]="false"
      (submit)="updateUser($event)"
      (delete)="deleteUser($event)"
    ></app-form>
  </div>
  <ng-template #footer>
    <div
      class="d-flex gap-2 justify-content-start"
      *ngIf="editUser"
    >
      <button
        type="button"
        pButton
        severity="danger"
        [outlined]="true"
        *ngIf="deleteButton"
        i18n="@@delete"
        (click)="editFormRef?.onDelete()"
      >Löschen</button>
      <button
        type="button"
        pButton
        [outlined]="true"
        (click)="editUserDrawer.close($event)"
        i18n="@@cancel"
      >Abbrechen</button>
      <button
        type="button"
        pButton
        [disabled]="!!editFormRef?.form?.invalid || !hasUserChanges() || saving"
        [loading]="saving"
        [severity]="saveFeedback === 'saved' ? 'success' : undefined"
        (click)="editFormRef?.onSubmit()"
      >
        <i
          *ngIf="saveFeedback === 'saved'"
          class="ri-check-line me-1"
        ></i>
        <span
          *ngIf="saveFeedback !== 'saved'"
          i18n="@@save"
        >Speichern</span>
        <span
          *ngIf="saveFeedback === 'saved'"
          i18n="@@globalSavedShort"
        >Gespeichert</span>
      </button>
    </div>
  </ng-template>
</p-drawer>

<p-drawer
  #createUserDrawer
  [(visible)]="createVisible"
  position="right"
  [style]="{width: 'min(880px, 95vw)'}"
  (onHide)="closeCreateUser()"
>
  <ng-template #header>
    <span
      class="fs-6 fw-bold"
      i18n="@@globalCreate"
    >Erstellen</span>
  </ng-template>
  <div *ngIf="createVisible">
    <app-form
      #createForm
      type="create"
      [data]="formFieldCreatorData"
      [formFields]="formFieldsCreator"
      [translatedLabels]="translatedLabels"
      [showActions]="false"
      (submit)="createUser($event)"
    ></app-form>
  </div>
  <ng-template #footer>
    <div
      class="d-flex gap-2 justify-content-start"
      *ngIf="createVisible"
    >
      <button
        type="button"
        pButton
        [outlined]="true"
        (click)="createUserDrawer.close($event)"
        i18n="@@cancel"
      >Abbrechen</button>
      <button
        type="button"
        pButton
        [disabled]="!!createFormRef?.form?.invalid || creating"
        [loading]="creating"
        i18n="@@save"
        (click)="createFormRef?.onSubmit()"
      >Speichern</button>
    </div>
  </ng-template>
</p-drawer>

<ng-template
  #excludeCrmIds
  let-data="data"
>
  <p i18n="@@excludeVkcs">Service deaktivieren:</p>
  <ng-container *ngFor="let vkc of this.vkcs">
    <button
      pButton
      class="my-1 me-2"
      [outlined]="!data.excludeCrmIds.includes(vkc.crm_id)"
      (click)="this.onToggleVkc(data, vkc.crm_id)"
    >{{vkc.name}}</button>
  </ng-container>
</ng-template>